<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import {
        AuthenticationFlow,
        Heading,
        Login,
        STATE,
        UpdatePassword,
    } from '@smatch/cassiopeia-web-components';

    // COMPONENTS
    import Registration from './pages/registration/Registration.svelte';

    // PLUGINS
    import { Router, Route } from 'svelte-navigator';

    // LAYOUT
    import LayoutAuthentication from 'src/app/library/layouts/layout-authentication/LayoutAuthentication.svelte';

    /* PROPS ----------------------------------------------------------------------------------- */

</script>

<LayoutAuthentication>

    <Router>

        <Route path = 'login'>
            <Heading size = 'xl'>Source top brands at unbeatable prices</Heading>
            <Heading size = 'md' style = 'subtle'>Sign-In to discover new deals.</Heading>
            <Login registrationUrl = '../registration'/>
        </Route>

        <Route path = 'registration'>
            <Heading size = 'xl'>Source top brands at unbeatable prices</Heading>
            <Heading size = 'md' style = 'subtle'>Create your free buyer account.</Heading>
            <Registration loginUrl = '../login' />
        </Route>

        <Route path = 'update-password'>
            <Heading size = 'xl'>Source top brands at unbeatable prices</Heading>
            <Heading size = 'md' style = 'subtle'>Sign-In to discover new deals.</Heading>
            <UpdatePassword />
        </Route>

        <Route>

            <Heading size = 'xl'>Source top brands at unbeatable prices</Heading>

            {#if $STATE.hasAuthenticated}
                <Heading size = 'md' style = 'subtle'>Sign-In to discover new deals.</Heading>
            {:else}
                <Heading size = 'md' style = 'subtle'>Create your free buyer account.</Heading>
            {/if}

            <AuthenticationFlow
                loginUrl = { `/authentication/login${ window.location.search }` }
                registrationUrl = '/authentication/registration'
            />

        </Route>

    </Router>

</LayoutAuthentication>